import React from 'react';

export default function SEOKeys() {
  return (
    <>
      <span className="keys">Twitch streamer</span>
      <span className="keys">Black Twitch streamer</span>
      <span className="keys">Black Twitch streamer - Noobtoons</span>
      <span className="keys">Gamer Girl</span>
      <span className="keys">Girl Gamer</span>
      <span className="keys">hot gamer girls</span>
      <span className="keys">Black Twitch UK</span>
      <span className="keys">Black Gamer</span>
      <span className="keys">Black Girl Gamer</span>
      <span className="keys">Black Gamer Girl</span>
      <span className="keys">popular twitch streamers</span>
      <span className="keys">Kick streamers</span>
      <span className="keys">Final Fantasy xvi</span>
      <span className="keys">Final Fantasy</span>
      <span className="keys">GTA V</span>
      <span className="keys">Grand Theft Auto V</span>
      <span className="keys">Twitch Con</span>
      <span className="keys">British Streamers</span>
      <span className="keys">Black British Streamers</span>
      <span className="keys">British Content Creator</span>
      <span className="keys">Tiktok Live Streamer</span>
      <span className="keys">Tiktok Streamer</span>
      <span className="keys">Tiktok Live - Noobtoons</span>
      <span className="keys">UK Influencer</span>
      <span className="keys">UK Black Influencer - Noobtoons</span>
    </>
  );
}
